import { Constrain, ControlLink, Stack, Text } from '@moda/om';
import React from 'react';

import './AccessibilityStatementPage.scss';
import { PageMeta } from '../../components/PageMeta';

export const AccessibilityStatementPage: React.FC = () => {
  return (
    <>
      <PageMeta title="Accessibility Statement" description="Accessibility Statement" />
      <div className="AccessibilityStatementPage">
        <Constrain>
          <Stack space={4}>
            <Text className="AccessibilityStatementPage__title" treatment="h2" family="serif">
              Accessibility Statement
            </Text>

            <div className="AccessibilityStatementPage__section">
              Moda Operandi strives to make our website accessible to all visitors. We recognize
              that accessibility and usability might not always be available in every area of our
              websites or for those using assistive technologies and devices.
            </div>

            <div className="AccessibilityStatementPage__section">
              Our efforts are ongoing as we improve our websites' accessibility features, and we
              welcome your questions or comments on how we can improve our website's accessibility.
              If you have any questions or comments, or if you need assistance with our site, please
              contact Customer Care at (800) 707-9898 or{' '}
              <ControlLink href="mailto:care@modaoperandi.com">care@modaoperandi.com</ControlLink>.
            </div>
          </Stack>
        </Constrain>
      </div>
    </>
  );
};
